<template>
   
  <v-row class="login-background">
    <v-col md="10" offset-md="1" style="padding: 64px;">
      <v-row no-gutters align="center"
             justify="end" style="height: 100%">
        <v-col md="7">
          <v-row>
            <h1 style="color: #fff;font-size: 28px;">{{ $vuetify.lang.t('$vuetify.custom.etBaseFramework') }}</h1>
          </v-row>
        </v-col>
        <v-col md="5">
          <v-row>
            <v-sheet
              width="410"
              height="390"
              class="mx-auto"
              flat
              tile
            >
              <v-card-actions class="pa-7">
                <v-row no-gutters>
                  <v-col cols="7">{{text}}</v-col>
                  <v-col cols="5">
                    <div class="ml-2 float-right" style="font-size: 28px;cursor:pointer;line-height:0px;"
                         @click="switchLogon">
                      <et-icon :icon-class="iconClass"></et-icon>
                    </div>
                    <v-img class="float-right login-tips" width="72" height="21" :src="imgSrc">
                      <v-row no-gutters align="center"
                             justify="center">
                        {{tips}}
                      </v-row>
                    </v-img>
                  </v-col>
                  <v-row no-gutters class="mt-2">
                    <code-login v-if="!isPassword"></code-login>
                    <password-login v-if="isPassword"></password-login>
                  </v-row>
                </v-row>

              </v-card-actions>
            </v-sheet>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import codeLogin from './code-login'
  import passwordLogin from './password-login'

  export default {
    name: 'login',
    data() {
      return {
        imgSrc: require('@/assets/u1061.png'),
        isPassword: true,
        iconClass: 'eterweimadenglu',
        text: this.$vuetify.lang.t('$vuetify.custom.login.passwordLogin'),
        tips: this.$vuetify.lang.t('$vuetify.custom.login.scanLogin'),
      }
    },
    methods: {
      switchLogon() {
        if (this.isPassword) {
          this.text = this.$vuetify.lang.t('$vuetify.custom.login.scanLogin');
          this.tips = this.$vuetify.lang.t('$vuetify.custom.login.passwordLogin');
          this.iconClass = 'etmimadenglu';
          this.isPassword = false;
        } else {
          this.text = this.$vuetify.lang.t('$vuetify.custom.login.passwordLogin');
          this.tips = this.$vuetify.lang.t('$vuetify.custom.login.scanLogin');
          this.iconClass = 'eterweimadenglu';
          this.isPassword = true;
        }
      }
    },
    components: {
      codeLogin, passwordLogin
    }
  }
</script>

<style>
  .login-background {
    height: 701px;
    background-color: rgba(204, 204, 204, 1);
  }

  .login-tips {
    font-family: 'Roboto,sans-serif';
    font-weight: 400;
    font-style: normal;
    font-size: 12px;
    color: #00C1DE;
    text-align: left;
  }
</style>
